// Types
import type {QuestionForDisplay} from '../../types/ballot'
// Styles
import styles from './photo-gallery-top-bar.module.scss'

type TopBarVariant = 'scroll' | 'flow' | 'flow-masonry'

interface PhotoGalleryTopBarProps {
  currentQuestion: QuestionForDisplay
  variant: TopBarVariant
  hasItems?: boolean
  onScroll?: (direction: number) => void
}

const PhotoGalleryTopBar = ({
  currentQuestion,
  variant,
  hasItems = false,
  onScroll,
}: PhotoGalleryTopBarProps) => {
  const variantClass = styles[`--${variant}`] || ''

  return (
    <div className={`${styles['photo-gallery-top-bar']} ${variantClass}`}>
      <div className={styles['__title']}>{currentQuestion?.name}</div>
      {hasItems && onScroll &&
        <div
          className={`buttons are-large ${variant === 'scroll' ? styles['mobile-hidden'] : ''}`}
          style={{
            flexWrap: 'nowrap',
            marginBottom: '0',
          }}
        >
          <button
            onClick={() => onScroll(-1)}
            className='button'
            style={{marginBottom: '0'}}
          >
            {'◀'}
          </button>
          <button
            onClick={() => onScroll(1)}
            className='button'
            style={{marginBottom: '0'}}
          >
            {'▶'}
          </button>
        </div>
      }
    </div>
  )
}

export default PhotoGalleryTopBar
